import { Injectable } from '@angular/core';
import { ProjectBudgetEntryModel } from '../../../../../../../core/models/project/project-budget-entry.model';
import { ProjectModel } from '../../../../../../../core/models/project/project.model';
import { assert } from '../../../../../../../core/assert/assert';
import { FeeUnit } from '../../../../../../../shared/data-types/unit-types';

@Injectable({
  providedIn: 'root',
})
export class BudgetEntryService {
  constructor() {}

  public createBudgetEntry(
    value: number,
    valueType: FeeUnit,
    taskId: number,
    memberId: number,
  ): ProjectBudgetEntryModel {
    const budgetEntry = new ProjectBudgetEntryModel();
    budgetEntry[valueType] = value;
    budgetEntry.memberId = memberId;
    budgetEntry.taskId = taskId;
    return budgetEntry;
  }

  public getEntryForTask(project: ProjectModel, taskId: number): ProjectBudgetEntryModel {
    const budgetEntry = project.projectBudgetEntries.filter((entry) => entry.taskId === taskId);
    assert(budgetEntry.length === 1);
    return budgetEntry[0];
  }

  public getEntryForMember(project: ProjectModel, memberId: number): ProjectBudgetEntryModel {
    const budgetEntries = project.projectBudgetEntries.filter(
      (entry) => entry.memberId === memberId,
    );
    assert(budgetEntries.length === 1);
    return budgetEntries[0];
  }
}
